module.exports = __webpack_public_path__ + "revicons.2feb69ccb596730c7292.eot";


//////////////////
// WEBPACK FOOTER
// D:/ptrans/front-end-customer/src/assets/components/revolution_slider/fonts/revicons/revicons.eot?5510888
// module id = ../../../../../src/assets/components/revolution_slider/fonts/revicons/revicons.eot?5510888
// module chunks = 2